import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
} from 'reactstrap';

import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import PropTypes from 'prop-types';
import moment from 'moment';
import AddonsImagesForm from './AddonsImagesForm';
import currencies from '../../../../../../../data/currencies';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_AddOns_By_Id,
  gAPI_QuestionOptionList,
} from '../../../../../../../constants/APIs';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../../../helpers/IntlMessages';

function AddOnsForm({
  visible,
  toggle,
  formLabel,
  submit,
  updateAddOnsData,
  id,
  propertyId,
  locale,
}) {
  const [isActive, setisActive] = useState(false);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [addOnsData, setAddOnsData] = useState(
    updateAddOnsData || {
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      displayText: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      displayFreeText: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: 'Conditions',
          languageCode: locale,
        },
      ],
      creator: 'Admin',
      tariffs: [
        {
          travelStartDate: '',
          travelEndDate: '',
          bookingStartDate: '',
          bookingEndDate: '',
          currency: 'NZD',
          price: 0,
          taxIncluded: true,
          tax: 0,
          status: 'Active',
          applicable: 'Nothing',
        },
      ],
      displayOrder: 1,
      searchTags: [],
    }
  );

  useEffect(() => {
    if (id !== undefined) {
      setisActive(true);
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_AddOns_By_Id}/${id}`,
      })
        .then((res) => {
          setAddOnsData(res.data);
          AxiosAPI({
            method: 'get',
            url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Addons`,
          })
            .then((res1) => {
              var options = [];
              try {
                res1.data.map((item) =>
                  options.push({
                    label: item.option,
                    value: item.option,
                    key: item.id,
                  })
                );
              } finally {
              }
              setTags(options);
              var selectedTags = [];
              try {
                if (res.data.searchTags !== null) {
                  res.data.searchTags.map((item) =>
                    selectedTags.push(
                      options.filter((cat) => cat.value === item)[0]
                    )
                  );
                }
              } finally {
              }
              setselectedTags(selectedTags);
            })
            .catch((err) => console.log('err', err));
        })
        .catch((err) => console.log('err', err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Addons`,
      })
        .then((res) => {
          var options = [];
          try {
            res.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
          } finally {
          }
          setTags(options);
        })
        .catch((err) => console.log('err', err));
    }
  }, [id]);

  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    }
  };

  const handleChangeTags = (selectedTags) => {
    setselectedTags(selectedTags);
    const tagsArr = selectedTags.map((elem) => elem.value);

    setAddOnsData({
      ...addOnsData,
      searchTags: tagsArr,
    });
  };

  const handleAddTariff = () => {
    const values = [...addOnsData.tariffs];
    values.push({
      travelStartDate: '',
      travelEndDate: '',
      bookingStartDate: '',
      bookingEndDate: '',
      currency: 'NZD',
      price: 0.0,
      taxIncluded: true,
      tax: 0.0,
      status: 'Active',
      applicable: 'Nothing',
    });
    setAddOnsData({ ...addOnsData, tariffs: values });
  };

  const handleRemoveTariff = (index) => {
    const values = [...addOnsData.tariffs];
    values.splice(index, 1);
    setAddOnsData({ ...addOnsData, tariffs: values });
  };

  const handleTariffInputChange = (index, event) => {
    const values = [...addOnsData.tariffs];
    switch (event.target.name) {
      case 'travelStartDate':
        values[index].travelStartDate = event.target.value;
        break;
      case 'travelEndDate':
        values[index].travelEndDate = event.target.value;
        break;
      case 'bookingStartDate':
        values[index].bookingStartDate = event.target.value;
        break;
      case 'bookingEndDate':
        values[index].bookingEndDate = event.target.value;
        break;
      case 'currency':
        values[index].currency = event.target.value;
        break;
      case 'price':
        values[index].price = event.target.value;
        break;
      case 'taxIncluded':
        values[index].taxIncluded = event.target.value;
        break;
      case 'tax':
        values[index].tax = event.target.value;
        break;
      case 'status':
        values[index].status = event.target.value;
        break;
      case 'applicable':
        values[index].applicable = event.target.value;
        break;

      default:
        break;
    }

    setAddOnsData({
      ...addOnsData,
      tariffs: values,
    });
  };

  const handleChangeNameArr = (e) => {
    if (addOnsData.name.length > 0) {
      const index = addOnsData.name.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setAddOnsData({
          ...addOnsData,
          name: [...addOnsData.name, newStatement],
        });
      } else {
        let newArr = [...addOnsData.name];
        newArr[index].statement = e.target.value;
        setAddOnsData({
          ...addOnsData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setAddOnsData({
        ...addOnsData,
        name: [...addOnsData.name, newStatement],
      });
    }
  };

  const handleChangeDisplayTextArr = (e) => {
    if (addOnsData.displayText.length > 0) {
      const index = addOnsData.displayText.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setAddOnsData({
          ...addOnsData,
          displayText: [...addOnsData.displayText, newStatement],
        });
      } else {
        let newArr = [...addOnsData.displayText];
        newArr[index].statement = e.target.value;
        setAddOnsData({
          ...addOnsData,
          displayText: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setAddOnsData({
        ...addOnsData,
        displayText: [...addOnsData.displayText, newStatement],
      });
    }
  };

  const handleChangeDisplayFreeTextArr = (e) => {
    if (addOnsData.displayFreeText.length > 0) {
      const index = addOnsData.displayFreeText.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setAddOnsData({
          ...addOnsData,
          displayFreeText: [...addOnsData.displayFreeText, newStatement],
        });
      } else {
        let newArr = [...addOnsData.displayFreeText];
        newArr[index].statement = e.target.value;
        setAddOnsData({
          ...addOnsData,
          displayFreeText: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setAddOnsData({
        ...addOnsData,
        displayFreeText: [...addOnsData.displayFreeText, newStatement],
      });
    }
  };

  const handleChangeConditionsArr = (e) => {
    if (addOnsData.conditions.length > 0) {
      const index = addOnsData.conditions.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setAddOnsData({
          ...addOnsData,
          conditions: [...addOnsData.conditions, newStatement],
        });
      } else {
        let newArr = [...addOnsData.conditions];
        newArr[index].statement = e.target.value;
        setAddOnsData({
          ...addOnsData,
          conditions: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setAddOnsData({
        ...addOnsData,
        conditions: [...addOnsData.conditions, newStatement],
      });
    }
  };

  const handleChangeArr = (e) => {
    const key = e.target.name;
    const value = e.target.value;

    setAddOnsData({
      ...addOnsData,
      [key]: [
        {
          statement: value,
          languageCode: 'en',
        },
      ],
    });
  };

  const handleChange = (e) => {
    setAddOnsData({
      ...addOnsData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    submit(addOnsData);
  };

  const selectCurrencies = currencies.sort(dynamicSort('label')).map((item) => {
    return <option value={item.value}>{item.label}</option>;
  });

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === '-') {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle} size="lg">
        <ModalHeader toggle={toggle}>{formLabel}</ModalHeader>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              {/* <pre>{JSON.stringify(addOnsData, null, 2)}</pre> */}
              <Row>
                <Colxx sm={12} className="mb-3">
                  <Label>Title</Label>
                  <Input
                    type="text"
                    value={getLocalStatement(addOnsData.name)}
                    onChange={handleChangeNameArr}
                    name="name"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>Display Text</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(addOnsData.displayText)}
                    onChange={handleChangeDisplayTextArr}
                    name="displayText"
                  />
                </Colxx>
                <Colxx sm={6} className="mb-3">
                  <Label>
                    Display Text (when offered free with a room booking)
                  </Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(addOnsData.displayFreeText)}
                    onChange={handleChangeDisplayFreeTextArr}
                    name="displayFreeText"
                  />
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Conditions</Label>
                  <Input
                    type="textarea"
                    value={getLocalStatement(addOnsData.conditions)}
                    name="conditions"
                    onChange={handleChangeConditionsArr}
                  />
                </Colxx>
                {isActive === true && (
                  <Colxx sm={4} className="mb-3">
                    <Label>Status</Label>
                    <Input
                      type="select"
                      value={addOnsData.status}
                      name="status"
                      onChange={handleChange}
                    >
                      <option value="Draft">Draft</option>
                      <option value="Active">Active</option>
                      <option value="Inactive">Inactive</option>
                      <option value="Archived">Archived</option>
                    </Input>
                  </Colxx>
                )}
                <Colxx sm={3}>
                  <Label for="displayOrder"><IntlMessages id='dashboards.displayOrder' /></Label>
                  <Input
                    type="number"
                    name="displayOrder"
                    min={0}
                    value={addOnsData.displayOrder}
                    onChange={handleChange}
                  />
                </Colxx>
                <Colxx sm={6}>
                  <FormGroup>
                    <Label for="bookingUrl">Search Tags</Label>
                    <Select
                      components={{ Input: CustomSelectInput }}
                      className="react-select"
                      classNamePrefix="react-select"
                      isMulti={true}
                      name="form-field-name"
                      value={selectedTags}
                      onChange={handleChangeTags}
                      options={tags}
                    />
                  </FormGroup>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
          <h4>Add-on Validity & Rates</h4>
          {addOnsData.tariffs.map((tariff, index) => (
            <Row key={`${tariff}~${index}`} style={{ marginBottom: '30px' }}>
              <Colxx sm={3} className="mb-3">
                <Label>Travel Start Date</Label>
                <Input
                  required
                  type="date"
                  name="travelStartDate"
                  value={moment(tariff.travelStartDate).format('YYYY-MM-DD')}
                  onChange={(event) => handleTariffInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Travel End Date</Label>
                <Input
                  required
                  type="date"
                  name="travelEndDate"
                  value={moment(tariff.travelEndDate).format('YYYY-MM-DD')}
                  onChange={(event) => handleTariffInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Booking Start Date</Label>
                <Input
                  required
                  type="date"
                  name="bookingStartDate"
                  value={moment(tariff.bookingStartDate).format('YYYY-MM-DD')}
                  onChange={(event) => handleTariffInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Booking End Date</Label>
                <Input
                  required
                  type="date"
                  name="bookingEndDate"
                  value={moment(tariff.bookingEndDate).format('YYYY-MM-DD')}
                  onChange={(event) => handleTariffInputChange(index, event)}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Currency</Label>
                <Input
                  required
                  name="currency"
                  type="select"
                  onChange={(event) => handleTariffInputChange(index, event)}
                  value={tariff.currency}
                >
                  {selectCurrencies}
                </Input>
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Price</Label>
                <Input
                  required
                  name="price"
                  type="number"
                  min="0"
                  onChange={(event) => handleTariffInputChange(index, event)}
                  value={tariff.price}
                />
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Tax Included in Price?</Label>
                <Input
                  required
                  name="taxIncluded"
                  type="select"
                  onChange={(event) => handleTariffInputChange(index, event)}
                  value={tariff.taxIncluded}
                >
                  <option value={true}>Yes</option>
                  <option value={false}>No</option>
                </Input>
              </Colxx>
              {tariff.taxIncluded === 'false' && (
                <Colxx sm={3} className="mb-3">
                  <Label>Tax Percentage</Label>
                  <InputGroup>
                    <Input
                      required
                      name="tax"
                      type="number"
                      min="0"
                      onChange={(event) =>
                        handleTariffInputChange(index, event)
                      }
                      value={tariff.tax}
                    />
                    <InputGroupAddon addonType="append">
                      <InputGroupText>%</InputGroupText>
                    </InputGroupAddon>
                  </InputGroup>
                </Colxx>
              )}
              <Colxx sm={3} className="mb-3">
                <Label>Applicable</Label>
                <Input
                  required
                  name="applicable"
                  type="select"
                  onChange={(event) => handleTariffInputChange(index, event)}
                  value={tariff.applicable}
                >
                  <option value="Nothing">Nothing</option>
                  <option value="PerStay">Per Stay</option>
                  <option value="PerNight">Per Night</option>
                  <option value="PerOrder">Per Order</option>
                  <option value="PerPerson">Per Person</option>
                </Input>
              </Colxx>
              <Colxx sm={3} className="mb-3">
                <Label>Status</Label>
                <Input
                  required
                  name="status"
                  type="select"
                  onChange={(event) => handleTariffInputChange(index, event)}
                  value={tariff.status}
                >
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </Input>
              </Colxx>

              <Colxx sm={3} className="mb-3">
                <Label style={{ opacity: '0%' }}>-</Label>
                <div>
                  <Button
                    onClick={handleAddTariff}
                    color="primary"
                    size="xs"
                    outline
                    style={{ margin: '6px' }}
                  >
                    + Add Rate
                  </Button>
                  {addOnsData.tariffs.length > 1 && (
                    <Button
                      onClick={() => handleRemoveTariff(index)}
                      color="secondary"
                      size="xs"
                      outline
                      style={{ margin: '6px' }}
                    >
                      -
                    </Button>
                  )}
                </div>
              </Colxx>
            </Row>
          ))}
          {addOnsData.images && (
            <AddonsImagesForm images={addOnsData.images} id={id} />
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleSubmit}>
            Save
          </Button>
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

AddOnsForm.propTypes = {
  formLabel: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  updateAddOnsData: PropTypes.shape({
    name: PropTypes.array.isRequired,
    displayText: PropTypes.array.isRequired,
    displayFreeText: PropTypes.array.isRequired,
    conditions: PropTypes.array.isRequired,
    status: PropTypes.string.isRequired,
    tariffs: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
};
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};
export default injectIntl(connect(mapStateToProps)(AddOnsForm));
